import { defineMessages } from "react-intl";

export const actionButtonsMessages = defineMessages({
  refund: {
    id: "K//bUK",
    defaultMessage: "Refund",
    description: "refund button",
  },
  editTracking: {
    id: "dTkmON",
    defaultMessage: "Edit tracking",
    description: "edit tracking button",
  },
  addTracking: {
    id: "bS7A8u",
    defaultMessage: "Add tracking",
    description: "add tracking button",
  },
});
